import {
  HOMEPAGE_SELECT_LANGUAGE,
  HOMEPAGE_CLEAR_DATA,
  HOMEPAGE_DATA_FETCH,
  HOMEPAGE_DATA_SUCCESS,
  HOMEPAGE_DATA_FAILURE
} from './actionTypes';

const initialState = {
  isLoaded: false,
  lang: '',
  error: []
};

export const homepageSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case HOMEPAGE_SELECT_LANGUAGE:
      return { ...state, lang: action.payload };
    case HOMEPAGE_CLEAR_DATA:
      return initialState;
    case HOMEPAGE_DATA_FETCH:
      return { ...state, isLoaded: false };
    case HOMEPAGE_DATA_SUCCESS:
      return { ...state, isLoaded: true };
    case HOMEPAGE_DATA_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/HomepageSettings/reducer.js